"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailRegex = exports.defaultRegex = void 0;
exports.defaultRegex = /^.+$/;
// tslint:disable-next-line:max-line-length
exports.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//# sourceMappingURL=patterns.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-sweetalert/dist/constants/patterns.js
// module id = 2099
// module chunks = 0